export class SystemParametersModel {
    Id: number;
    BuyerPremium: number;
    VendorPremium: number;
    MixedLotWineId: number;
    UnallocatedVendorId: number;
    QuoteApprovalThreshold: number = 10000;

    constructor() {

    }
}